// @flow
import { isUndef } from 'utils';
import createFilter from './createFilter';

export default (value: any): string => {
  if (isUndef(value)) { return ''; }
  const string = String(value);

  return createFilter('#####-###', string);
};
